export default "__VITE_ASSET__2ab53c7c__"